import { auth } from "../firebase";

// Le chiamate passano dal proxy crm.php (stesso server della dashboard): SuiteCRM non espone
// header CORS e le credenziali di api_user devono restare lato server. Il proxy accetta solo
// utenti Firebase @algores.it, verificandone l'ID token.
const CRM_API_URL = "https://dge.algores.it/api/crm.php";

async function chiamaAPI(method, restData) {
  if (!auth.currentUser) throw new Error("Utente non autenticato");
  const idToken = await auth.currentUser.getIdToken();

  const response = await fetch(CRM_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ idToken, method, restData }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Errore chiamata SuiteCRM");
  return data;
}

// Crea opportunità in SuiteCRM quando l'evento passa a preventivo
export async function creaOpportunitaCRM(evento, nomeCliente, accountId = null) {
  try {
    const dataChiusura = evento.dataInizio || evento.data || "";

    const nameValueList = {
      name: { name: "name", value: `${nomeCliente} - ${evento.titolo}` },
      description: { name: "description", value: evento.descrizione || "" },
      amount: { name: "amount", value: evento.budget || evento.importoVendita || "0" },
      close_date: { name: "close_date", value: dataChiusura },
      sales_stage: { name: "sales_stage", value: "Proposal/Price Quote" },
      lead_source: { name: "lead_source", value: "Internal" },
    };

    if (accountId) {
      nameValueList.account_id = { name: "account_id", value: accountId };
    }

    const result = await chiamaAPI("set_entry", {
      module_name: "Opportunities",
      name_value_list: nameValueList,
    });

    console.log("Opportunità CRM creata:", result);
    return result.id;
  } catch (error) {
    console.error("Errore creazione opportunità CRM:", error);
    return null;
  }
}

// Crea task di fatturazione in SuiteCRM quando l'evento è completato
export async function creaTaskFatturazione(evento, nomeCliente) {
  try {
    const nameValueList = {
      name: { name: "name", value: `Fatturazione — ${nomeCliente} - ${evento.titolo}` },
      status: { name: "status", value: "Not Started" },
      priority: { name: "priority", value: "High" },
      date_due: { name: "date_due", value: evento.dataInizio || evento.data || "" },
      description: {
        name: "description",
        value: `Evento completato. Importo: € ${evento.importoVendita || "N/D"}`,
      },
    };

    const result = await chiamaAPI("set_entry", {
      module_name: "Tasks",
      name_value_list: nameValueList,
    });

    console.log("Task fatturazione CRM creato:", result);
    return result.id;
  } catch (error) {
    console.error("Errore creazione task CRM:", error);
    return null;
  }
}

// Recupera lista account da SuiteCRM
export async function getAccountsCRM() {
  try {
    const tutti = [];
    let offset = 0;
    const pageSize = 100;

    while (true) {
      const result = await chiamaAPI("get_entry_list", {
        module_name: "Accounts",
        query: "",
        order_by: "name",
        offset,
        select_fields: ["id", "name"],
        max_results: pageSize,
      });

      if (!result.entry_list || result.entry_list.length === 0) break;

      result.entry_list.forEach((entry) => {
        tutti.push({
          id: entry.id,
          nome: entry.name_value_list?.name?.value || "",
        });
      });

      if (result.entry_list.length < pageSize) break;
      offset += pageSize;
    }

    return tutti.sort((a, b) => a.nome.localeCompare(b.nome, "it"));
  } catch (error) {
    console.error("Errore recupero account CRM:", error);
    return [];
  }
}

export async function creaAccountCRM(nomeAccount) {
  try {
    const nameValueList = {
      name: { name: "name", value: nomeAccount },
    };

    const result = await chiamaAPI("set_entry", {
      module_name: "Accounts",
      name_value_list: nameValueList,
    });

    console.log("Account CRM creato:", result);
    return result.id;
  } catch (error) {
    console.error("Errore creazione account CRM:", error);
    return null;
  }
}

export async function getOpportunitaPerAccount(accountId) {
  if (!accountId) return [];
  try {
    const tutti = [];
    let offset = 0;
    const pageSize = 100;

    while (true) {
      const result = await chiamaAPI("get_entry_list", {
        module_name: "Opportunities",
        query: "",
        order_by: "opportunities.name",
        offset,
        select_fields: ["id", "name", "sales_stage", "close_date", "amount", "account_id"],
        max_results: pageSize,
      });

      if (!result.entry_list || result.entry_list.length === 0) break;

      result.entry_list
        .filter((entry) => {
          const accountMatch = entry.name_value_list?.account_id?.value === accountId;
          const stage = entry.name_value_list?.sales_stage?.value || "";
          const statoEscluso = ["Closed Lost", "Closed Won", "Disdetto"].includes(stage);
          return accountMatch && !statoEscluso;
        })
        .forEach((entry) => {
          tutti.push({
            id: entry.id,
            nome: entry.name_value_list?.name?.value || "",
            stage: entry.name_value_list?.sales_stage?.value || "",
            data: entry.name_value_list?.close_date?.value || "",
            importo: entry.name_value_list?.amount?.value || "",
          });
        });

      if (result.entry_list.length < pageSize) break;
      offset += pageSize;
    }

    return tutti.sort((a, b) => a.nome.localeCompare(b.nome, "it"));
  } catch (error) {
    console.error("Errore recupero opportunità:", error);
    return [];
  }
}

export async function creaOpportunitaManuale(nomeOpportunita, accountId, dataChiusura = "", importo = "") {
  try {
    const nameValueList = {
      name: { name: "name", value: nomeOpportunita },
      sales_stage: { name: "sales_stage", value: "Proposal/Price Quote" },
    };
    if (accountId) nameValueList.account_id = { name: "account_id", value: accountId };
    if (dataChiusura) nameValueList.close_date = { name: "close_date", value: dataChiusura };
    if (importo) nameValueList.amount = { name: "amount", value: importo };

    const result = await chiamaAPI("set_entry", {
      module_name: "Opportunities",
      name_value_list: nameValueList,
    });

    return { id: result.id, nome: nomeOpportunita, stage: "Proposal/Price Quote", data: dataChiusura, importo };
  } catch (error) {
    console.error("Errore creazione opportunità:", error);
    return null;
  }
}

export async function aggiornaImportoOpportunita(opportunitaId, importo) {
  if (!opportunitaId || !importo) return;
  try {
    const nameValueList = {
      id: { name: "id", value: opportunitaId },
      amount: { name: "amount", value: String(importo) },
    };
    await chiamaAPI("set_entry", {
      module_name: "Opportunities",
      name_value_list: nameValueList,
    });
    console.log("Importo opportunità CRM aggiornato:", importo);
  } catch (error) {
    console.error("Errore aggiornamento importo CRM:", error);
  }
}

export async function aggiornaStatoOpportunita(opportunitaId, statoEvento) {
  if (!opportunitaId) return;

  const MAPPA_STATI = {
    "chiusoAcquisito": "Closed Won",
    "chiusoPerso": "Closed Lost",
    "annullato": "Disdetto",
  };

  const salesStage = MAPPA_STATI[statoEvento];
  if (!salesStage) return;

  try {
    await chiamaAPI("set_entry", {
      module_name: "Opportunities",
      name_value_list: {
        id: { name: "id", value: opportunitaId },
        sales_stage: { name: "sales_stage", value: salesStage },
      },
    });
    console.log(`Stato opportunità CRM aggiornato a: ${salesStage}`);
  } catch (error) {
    console.error("Errore aggiornamento stato opportunità CRM:", error);
  }
}